import { useEffect, useState } from 'react';
import { DoughnutChart } from '../../../../../shared/components/Charts/components/Doughnut';
import SkeletonChart from '../../../../../Dashboard/components/AdminDashboard/components/IncidenciasTab/components/SkeletonChart';
import useScreenWidth from '../../../../../../../../hooks/useScreenWidth';
import { useSelector } from 'react-redux';

export const EnviosCharts = ({ data }) => {
    const screenWidth = useScreenWidth();
    const { isLoading } = useSelector(state => state.envios);
    const [chartsData, setChartsData] = useState(null);
    const [sizeContainerChart, setSizeContainerChart] = useState({
        width: 0,
        height: 0,
    });
    const backgroundColors = [
        '#8ED7D7',
        '#FFB356',
        '#97C126',
        '#FF8CA0',
        '#00B0BD',
        '#FFCD8F',
        '#BDD372',
        '#F45F74',
    ];

    const handleMetricCharts = () => {
        const labels = [];
        const nacional = [];
        const general = [];
        const internacional = [];

        data.forEach((state) => {
            if (state.estado_id !== 7) {
                labels.push(state.nombre);
                nacional.push(state.count_nacional);
                general.push(state.count_nacional + state.count_internacional);
                internacional.push(state.count_internacional);
            }
        });

        setChartsData({
            labels,
            nacional,
            general,
            internacional,
        });
    };

    useEffect(() => {
        //calcular size container skeleton
        let width;

        if (screenWidth>= 992) {
            width = (screenWidth - 32) / 3;
        } else if (screenWidth > 767) {
            width = (screenWidth - 32) / 2;
        } else {
            width = screenWidth - 32;
        }

        setSizeContainerChart({
            width,
            height: width,
        });
    }, [screenWidth]);

    useEffect(() => {
        if (data) {
            handleMetricCharts();
        }
    }, [data]);

    return (
        <div className="w-100 d-flex flex-wrap flex-lg-nowrap align-items-center mt-3">
            <div className="col-12 col-md-6 col-lg-4 pe-0 pe-md-3 align-items-center">
                {(isLoading || !chartsData) ? (
                    <SkeletonChart sizeContainerChart={sizeContainerChart} className='envios-chart' />
                ) : chartsData?.nacional &&
                  Math.max(...chartsData?.nacional) > 0 ? (
                    <DoughnutChart
                        title={'Nacional'}
                        dataset={{
                            labels: chartsData?.labels,
                            datasets: [
                                {
                                    label: 'Nacional',
                                    data: chartsData?.nacional,
                                    backgroundColor: backgroundColors,
                                    borderColor: backgroundColors,
                                    borderWidth: 1,
                                },
                            ],
                        }}
                    />
                ) : (
                    <p className="text-center">
                        No hay datos de envíos nacionales.
                    </p>
                )}
            </div>

            <div className="col-12 col-md-6 col-lg-4 pe-0 pe-md-3">
                {(isLoading || !chartsData)? (
                    <SkeletonChart sizeContainerChart={sizeContainerChart}  className='envios-chart'/>
                ) : chartsData?.general &&
                  Math.max(...chartsData?.general) > 0 ? (
                    <DoughnutChart
                        title={'General'}
                        dataset={{
                            labels: chartsData?.labels,
                            datasets: [
                                {
                                    label: 'General',
                                    data: chartsData?.general,
                                    backgroundColor: backgroundColors,
                                    borderColor: backgroundColors,
                                    borderWidth: 1,
                                },
                            ],
                        }}
                    />
                ) : (
                    <p className="text-center">No hay datos de envíos.</p>
                )}
            </div>

            <div className="col-12 col-md-6 col-lg-4 ps-0 ps-md-3">
                {(isLoading || !chartsData) ? (
                    <SkeletonChart sizeContainerChart={sizeContainerChart} className='envios-chart'/>
                ) : chartsData?.internacional &&
                  Math.max(...chartsData?.internacional) > 0 ? (
                    <DoughnutChart
                        title={'Internacional'}
                        dataset={{
                            labels: chartsData?.labels,
                            datasets: [
                                {
                                    label: 'Internacional',
                                    data: chartsData?.internacional,
                                    backgroundColor: backgroundColors,
                                    borderColor: backgroundColors,
                                    borderWidth: 1,
                                },
                            ],
                        }}
                    />
                ) : (
                    <p className="text-center">
                        No hay datos de envíos internacionales.
                    </p>
                )}
            </div>
        </div>
    );
};
